import UserWithAccess from './UserWithAccess.component';

export default UserWithAccess;
